var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
const QuiFlex = (_a) => {
    var { dir, gap, align, justify, padding, fullWidth, minWidth, maxWidth, children, className, style } = _a, otherProps = __rest(_a, ["dir", "gap", "align", "justify", "padding", "fullWidth", "minWidth", "maxWidth", "children", "className", "style"]);
    const gapSuffix = gap ? `-${gap}` : "";
    const cn = classNames(`qui-flex-${dir}${gapSuffix}`, fullWidth && "qui-w-100", align && `qui-align-${align}`, justify && `qui-justify-${justify}`, padding && `qui-padding-${padding.replace(" ", "-")}`, className);
    return (React.createElement(QuiFlexItem, Object.assign({ className: cn, style: Object.assign(Object.assign({}, style), { maxWidth, minWidth }) }, otherProps), children));
};
/** A primitive layout component for laying elements horizontally or vertically with consistent spacing, padding, justification, and alignment.
 * Can be nested with other QuiFlex components to create complex layouts.
 * Note: Individual children can be given extra space by applying the `qui-offset-{size}` class.
 */
export const QuiFlexH = (props) => React.createElement(QuiFlex, Object.assign({ dir: "h" }, props));
export const QuiFlexV = (props) => React.createElement(QuiFlex, Object.assign({ dir: "v" }, props));
export const QuiFlexItem = (_a) => {
    var { children, className, alignSelf, flexSelf, offset, as: CustomTag } = _a, otherProps = __rest(_a, ["children", "className", "alignSelf", "flexSelf", "offset", "as"]);
    const cn = classNames(className, {
        "qui-grow": flexSelf === "grow",
        "qui-flex-fullwidth": flexSelf === "fullWidth",
        "qui-no-shrink": flexSelf === "none",
        [`qui-align-self-${alignSelf}`]: !!alignSelf,
        [`qui-offset-${offset}`]: !!offset,
    });
    const Tag = CustomTag !== null && CustomTag !== void 0 ? CustomTag : "div";
    return (React.createElement(Tag, Object.assign({ className: cn }, otherProps), children));
};
